import React from "react";
import CheckCircle  from "@material-ui/icons/CheckCircle";
import {Snackbar} from "../"




export default class InfoNotification extends React.Component {

    state={
        isOpen:true
    }

    timer =null

    componentDidMount(){
        this.timer =setTimeout(
            function() {
                this.setState({isOpen:false})
            }.bind(this),
            6000
        );
    }

    componentWillUnmount(){
        clearInterval(this.timer)
    }




    render(){
        const info = 'Email has been sent'
        const {isOpen} = this.state
        const {message} = this.props
        return(
            <div>
                <Snackbar
                    place="bc"
                    color="success"
                    icon={CheckCircle}
                    message={message}
                    open={isOpen}
                    closeNotification={()=>{
                        this.setState({isOpen:false})
                    }}
                    close
                />
            </div>
        )
    }




}


// WEBPACK FOOTER //
// ./src/components/Snackbar/InfoNotification.jsx